export const WEB_PAGE_SITE_MAP_INFO = 'info'
